import "./App.css";
import "./output.css";

import SmoothScroll from "smooth-scroll";

// Main Site Pages
import HomePage from "./main-site-pages/HomePage.js";
import SolutionsHomePage from "./main-site-pages/SolutionsHomePage.js";
import LoginLanding from "./main-site-pages/login/LoginLandingPage.jsx";
import UnderConstruction from "./main-site-pages/UnderConstruction.js";
import ResetPassword from "./main-site-pages/login/ResetPassword.jsx";
import Subscription from "./main-site-pages/Subscription.jsx";
import ACTRegistration from "./main-site-pages/misc/ACTRegistration.jsx";
import NotFoundPage from "./main-site-pages/NotFoundPage.jsx";
import ACTFreeTrialRedirect from "./main-site-pages/misc/ACTFreeTrialRedirect.jsx";
import EmailVerificationPage from "./main-site-pages/login/EmailVerificationPage.jsx";
import About from "./main-site-pages/about.jsx";
import Products from "./main-site-pages/Products.jsx";
import Contact from "./main-site-pages/Contact.jsx";
import Resources from "./main-site-pages/Resources.jsx";
import TermsAndConditions from "./main-site-pages/TermsAndConditions.jsx";
import PrivacyPolicy from "./main-site-pages/PrivacyPolicy.jsx";
import CookiePolicy from "./main-site-pages/CookiePolicy.jsx";
import SubscriptionConfirmation from "./main-site-pages/SubscriptionConfirmation.js";

// Main Page Layout
import MainLayout from "./components/layout/MainLayout.jsx";

// Site Info Pages
import FleetOwners from "./main-site-pages/solutions-info/FleetOwners.jsx";
import ChargerDevelopers from "./main-site-pages/solutions-info/ChargerDevelopers.jsx";
import Regulators from "./main-site-pages/solutions-info/Regulators.jsx";
import Utilities from "./main-site-pages/solutions-info/Utilities.jsx";

// Apps
import BasicCalculator from "./apps/fleet_planning/basicCalculator.js";

// Pro Calculator / Fleet Planning
import FleetPlanningDashboard from "./apps/fleet_planning/fleetPlanningDashboard.js";
import Profile from "./main-site-pages/profile.js";
import Inputs from './apps/fleet_planning/inputs.js';
import Analytics from './apps/fleet_planning/analytics.js';

// Charger Planning
import ChargerPlanningDashboard from "./apps/charger_planning/chargerPlanningDashboard.js";
import ChargerMapView from "./apps/charger_planning/chargerMapView.js";
import ChargerTableView from "./apps/charger_planning/chargerTableView.js";

// Auth Context
import { AuthProvider } from "./components/router/authContext.jsx";
import { ProtectedRoute } from "./components/router/auth/ProtectedRoute.jsx";
import { PublicRoute } from "./components/router/auth/PublicRoute.jsx";


// JS Imports
import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { initGA, PageTracker, debugLog, GADebugger } from "./utils/analytics";
import { GoogleMapsProvider } from "./contexts/GoogleMapsContext";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

function App() {
  useEffect(() => {
    initGA();
    if (process.env.NODE_ENV === "development") {
      debugLog("GA4 Initialized in debug mode");
    }
  }, []);

  return (
    <AuthProvider>
      <GoogleMapsProvider>
        <Router>
          <PageTracker />
          <GADebugger />
          <Routes>
            {/* Public routes with MainLayout */}
            <Route element={<PublicRoute />}>
              <Route element={<MainLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/solutions" element={<SolutionsHomePage />} />
                <Route path="/fleet-planning-basic" element={<BasicCalculator />} />
                <Route path="/basic" element={<BasicCalculator />} />
                <Route path="/subscription" element={<Subscription />} />
                <Route path="/act-registration" element={<ACTRegistration />} />
                <Route path="/construction" element={<UnderConstruction />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/fleet-owners" element={<FleetOwners />} />
                <Route path="/charging-station-developers" element={<ChargerDevelopers />} />
                <Route path="/regulators" element={<Regulators />} />
                <Route path="/utilities" element={<Utilities />} />
                <Route path="/confirmation" element={<SubscriptionConfirmation />} />
              </Route>
            </Route>
            
            {/* Standalone public routes */}
            <Route element={<PublicRoute />}>
              <Route path="/login" element={<LoginLanding />} />
              <Route path="/login/:token" element={<ACTFreeTrialRedirect />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>

            {/* Verification route - standalone */}
            <Route path="/verify-email/:token" element={<EmailVerificationPage />} />

            {/* Protected routes - only for authenticated users */}
            <Route element={<ProtectedRoute />}>
              {/* Fleet Planning */}
              <Route path="/fleet-planning-pro" element={<FleetPlanningDashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/inputs" element={<Inputs />} />
              <Route path="/analytics" element={<Analytics />} />

              {/* Charger Planning */}
              <Route path="/charger-planning-pro" element={<ChargerPlanningDashboard />} />
              <Route path="/charger-map-view" element={<ChargerMapView />} />
              <Route path="/charger-table-view" element={<ChargerTableView />} />
            </Route>
          </Routes>
        </Router>
      </GoogleMapsProvider>
    </AuthProvider>
  );
}

export default App;
